export enum DisplayAreaType {
  Product = 1,
  Model = 2,
  ModelVersion = 3,
  Category = 4,
  Brand = 5,
}

export interface DisplayAreaItem {
  id?: string;
  referenceId: string;
  displayOrder: number;
}

export interface DisplayArea {
  id: string;
  name: string;
  slug: string;
  description?: string;
  itemType: DisplayAreaType;
  maxItems: number;
  isActive: boolean;
  items: DisplayAreaItem[];
}

export interface DisplayAreaList {
  id: string;
  name: string;
  slug: string;
  description?: string;
  itemType: DisplayAreaType;
  maxItems: number;
  isActive: boolean;
}

export interface UpdateDisplayArea {
  name: string;
  description?: string;
  items: DisplayAreaItem[];
}
